// connectionOverlay.js
// Controlador simple (pub/sub) para el overlay global de "sin conexión".
// setupAxios.js lo dispara cuando detecta un error de red/timeout; el
// componente <ConnectionOverlay /> (montado una vez en App.jsx) se suscribe
// para pintar el aviso, sin que axios (JS plano) dependa de React.

let listeners = [];
let activeCount = 0; // nº de peticiones actualmente en fase de reintento/fallo
let phase = "retrying"; // "retrying" | "failed"
let visible = false;
let retryCallbacks = new Set();

function emit() {
  const state = { visible, phase };
  listeners.forEach((fn) => fn(state));
}

export function subscribe(fn) {
  listeners.push(fn);
  fn({ visible, phase });
  return () => {
    listeners = listeners.filter((l) => l !== fn);
  };
}

// Se llama al empezar a reintentar una petición fallida.
export function beginRetrying() {
  activeCount += 1;
  visible = true;
  phase = "retrying";
  emit();
}

// Se llama cuando una petición agota sus reintentos automáticos.
export function markFailed() {
  phase = "failed";
  emit();
}

// Se llama cuando una petición termina (con éxito o tras rendirse el usuario).
export function endAttempt() {
  activeCount = Math.max(0, activeCount - 1);
  if (activeCount === 0) {
    visible = false;
    phase = "retrying";
  }
  emit();
}

// El botón "Reintentar" del overlay dispara todos los reintentos manuales pendientes.
export function registerRetry(fn) {
  retryCallbacks.add(fn);
}
export function unregisterRetry(fn) {
  retryCallbacks.delete(fn);
}
export function retryAll() {
  retryCallbacks.forEach((fn) => fn());
}

// Válvula de escape: si UNA petición concreta queda "huérfana" (el componente
// que la pidió ya ni siquiera sigue en pantalla, o el fallo es permanente y no
// una desconexión real), nada la vuelve a intentar salvo el botón — y como el
// overlay solo se oculta cuando TODAS las registradas acaban bien, esa única
// huérfana podía dejar bloqueada la pantalla para siempre aunque el resto de
// la app funcionase perfectamente. "Descartar" corta ese bloqueo a mano: deja
// de contar los intentos pendientes y oculta el aviso, sin tocar la sesión.
export function dismiss() {
  activeCount = 0;
  retryCallbacks.clear();
  visible = false;
  phase = "retrying";
  emit();
}
